"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * PDF Go API
 * This is a starting point for a Ripple Health Group API application.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: ch_engineering@calm.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./configuration"), exports);
tslib_1.__exportStar(require("./models"), exports);
tslib_1.__exportStar(require("./additional-types"), exports);
//# sourceMappingURL=index.js.map